<template>
  <v-dialog
    v-model="value"
    class="user_modal_dialog"
    max-width="528"
    persistent
    @click:outside="close"
  >
    <validation-observer ref="createOrderForm" v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(createOrder)">
        <v-card>
          <v-card-title>
            <span class="headline title_modal_user">
              {{ orderItemFormTitle }}
            </span>
            <v-icon class="info_modal_close" @click="close">mdi-close </v-icon>
          </v-card-title>
          <v-card-text class="main_modal pb-4">
            <v-container class="pa-0 user_modal_form">
              <div class="row no-gutters py-1">
                <div class="col-sm-6 col-12 pt-sm-2 pt-2 medium_15_01456A">
                  {{ $t("categoryTMC") }}
                </div>
                <vue-select
                  @input="productCode.code = null"
                  v-model="filterProduct.type_id"
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getProductTypes', {
                        name: text,
                        page,
                        limit: 15,
                      })
                  "
                  :items="productTypes"
                  :name="$t('type')"
                  class="col-sm-6 col-12 product-select-in-modal"
                  @next-page-resolved="
                    (data) => setProductType([...productTypes, ...data])
                  "
                  clearable
                  infinite
                  @item-resolved="setProductType"
                ></vue-select>
              </div>
              <div class="row no-gutters py-1">
                <div class="col-sm-6 col-12 medium_15_01456A">
                  <div class="d-flex align-center justify-space-between">
                    <span>{{ $t("product") }}*</span>
                    <custom-input-text
                      v-model="productCode.code"
                      :loading="productCode.loading"
                      :placeholder="$t('productCode')"
                      class="user_input mr-sm-4 no-margin"
                      hide-details
                      style="width: 100px"
                      @input="getProductWithCode"
                    ></custom-input-text>
                  </div>
                </div>
                <div class="flex-grow-1" style="max-width: 247px">
                  <vue-select
                    @input="getProductOne"
                    rules="required"
                    :name="$t('product')"
                    class="product-select-in-modal"
                    @item-resolved="setProduct"
                    v-model="orderRequestItem.product_id"
                    :getItemPromise="
                      ({ text, page }) =>
                        $store.dispatch('getProducts', {
                          name: text,
                          page,
                          limit: 15,
                        })
                    "
                    :items="products"
                    @next-page-resolved="
                      (data) => setProduct([...products, ...data])
                    "
                    infinite
                  >
                    <template #option="{ item }">
                      <v-list-item-title>
                        <p class="ma-0">{{ item.name }}</p>
                        <span class="v-messages">{{
                          item.attrs.join(" && ")
                        }}</span>
                      </v-list-item-title>
                    </template>
                  </vue-select>
                </div>
              </div>
              <div class="row no-gutters py-1">
                <div class="col-sm-6 col-12 pt-sm-5 pt-2 medium_15_01456A">
                  {{ $t("unit") }}*
                </div>
                <custom-select
                  v-model="orderRequestItem.unitTypeId"
                  :item-text="`name_${$i18n.locale}`"
                  :items="unitTypes"
                  :name="$t('measure')"
                  class="col-sm-6 col-12 user_input no-margin"
                  rules="required"
                ></custom-select>
              </div>
              <div class="row no-gutters py-1">
                <div
                  class="col-sm-6 col-12 pt-sm-5 pt-2 medium_15_01456A d-flex align-center"
                >
                  {{ $t("count") }}*
                  <v-tooltip
                    v-if="
                      currentOrderFormStatus ===
                      orderFormStatus.addCountToOrderItem
                    "
                    color="#fff"
                    left
                    nudge-right="10"
                    nudge-top="35"
                  >
                    <template #activator="{ on, attrs }">
                      <v-sheet
                        v-bind="attrs"
                        v-on="on"
                        class="ml-4 px-2 py-1 rounded"
                        color="primary"
                        dark
                        >{{ lastProductCount }} +
                      </v-sheet>
                    </template>
                    <template #default>
                      {{ $t("addMoreProductToRequest") }}
                    </template>
                  </v-tooltip>
                </div>
                <custom-input-text
                  v-model="orderRequestItem.count"
                  :name="$t('count')"
                  :precision="2"
                  class="col-sm-6 col-12 user_input no-margin"
                  rules="required|max_value:1000000"
                  @keydown="numberOnly"
                ></custom-input-text>
              </div>
            </v-container>
            <div class="text-right">
              <v-btn color="primary" type="submit">{{ $t("save") }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { debounce } from "@/utils/pureFunctions";
import { numberOnly } from "@/utils/inputRegExps";
import VueSelect from "@/components/ui/vue-select/VueSelect";

const orderFormStatus = {
  addOrder: "addOrder",
  editOrderItem: "editOrderItem",
  addOrderItem: "addOrderItem",
  addCountToOrderItem: "addCountToOrderItem",
};

let watcherProductFilter = null;
export default {
  name: "DivisionOrderDialog",
  props: {
    updateTableOrder: {
      type: Function,
    },
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      productTypes: [],
      productCode: {
        code: null,
        loading: false,
      },
      lastProductCount: null,
      orderRequestItem: {
        product_id: null,
        productGroupId: null,
        productTypeId: null,
        unitType: null,
        file: [],
        order_id: null,
        id: null,
      },
      products: [],
      filterProduct: {
        type_id: null,
      },
      currentOrderFormStatus: orderFormStatus.editOrderItem,
    };
  },
  components: {
    VueSelect,
  },
  computed: {
    orderFormStatus: () => orderFormStatus,
    unitTypes() {
      if (this.orderRequestItem && this.orderRequestItem.product_id) {
        const selectedProduct = this.products.find(
          (item) => this.orderRequestItem.product_id === item.id
        );
        if (selectedProduct) {
          return selectedProduct.unitTypes;
        }
      }
      return [];
    },
    numberOnly: () => numberOnly,
    orderItemFormTitle() {
      return this.$t("edit");
    },
  },
  methods: {
    setProduct(products) {
      this.products = products;
    },
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    clearOrderForm() {
      this.lastProductCount = null;
      this.orderRequestItem = {
        product_id: null,
        product_category_id: null,
        unitType: null,
        warehouse_id: 0,
        order_id: null,
        file: [],
      };
      const { createOrderForm } = this.$refs;
      if (createOrderForm) {
        createOrderForm.reset();
      }
    },
    editItem(order, orderItem) {
      this.value = true;
      if (orderItem) {
        const {
          count,
          id,
          unitTypeId,
          productId,
          attachmentLink,
          attachmentFileName,
        } = orderItem;
        this.filterProduct.productId = productId;
        const data = {
          count,
          unitTypeId: unitTypeId,
          id,
          product_id: productId,
          attachmentFileName,
          attachmentLink,
        };
        this.orderRequestItem = { ...data };
        this.currentOrderFormStatus = orderFormStatus.editOrderItem;
      }
      this.orderRequestItem.order_id = order.id;
      this.orderRequestItem.numb = order.numb;
    },
    async getProducts(filterParams) {
      const { productSearchInput } = this.$refs;
      let params = filterParams || { pagination: false };
      if (productSearchInput) productSearchInput.loading = true;
      try {
        const { data } = await this.$store.dispatch("getProducts", params);
        this.products = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        if (productSearchInput) productSearchInput.loading = false;
      }
    },
    async createOrder() {
      try {
        this.showLoading();
        const formData = new FormData();
        let { count, product_id, unitTypeId, order_id, id } =
          this.orderRequestItem;
        count = count.replace(",", ".").replace(/\s/g, "");
        if (this.lastProductCount) {
          count = `${parseFloat(count) + parseFloat(this.lastProductCount)}`;
        }
        formData.append("product_id", product_id);
        formData.append("count", count);
        formData.append("unitTypeId", unitTypeId);
        if (order_id) {
          formData.append("order_id", order_id);
        }
        if (id) {
          formData.append("id", id);
        }
        await this.$http.post("orders/add-item", formData);
        await this.updateTableOrder();
        this.close();
        this.setSuccess({
          title: this.$t("successfullySaved"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    getProductOne() {
      if (this.unitTypes.length === 1) {
        this.orderRequestItem.unitTypeId = this.unitTypes[0].id;
      }
      if (
        this.currentOrderFormStatus !== orderFormStatus.addOrder &&
        this.currentOrderFormStatus !== orderFormStatus.editOrderItem
      ) {
        this.$http
          .get("orders/get-one", {
            params: {
              orderId: this.orderRequestItem.order_id,
              productId: this.orderRequestItem.product_id,
            },
          })
          .then((res) => {
            if (res.data.data) {
              this.currentOrderFormStatus = orderFormStatus.addCountToOrderItem;
              this.orderRequestItem.unitTypeId = parseInt(
                res.data.data["unitType_id"]
              );
              this.orderRequestItem.id = res.data.data.id;
              this.lastProductCount = res.data.data.count;
            } else {
              this.currentOrderFormStatus = orderFormStatus.addOrderItem;
              this.orderRequestItem.id = null;
            }
          });
      }
    },
    close() {
      this.value = false;
    },
    getProductWithCode() {},
  },
  watch: {
    value(val) {
      if (watcherProductFilter) {
        watcherProductFilter();
        watcherProductFilter = null;
      }
      if (val) {
        this.$nextTick(() => {
          this.getPRoductsWithDelay();
          watcherProductFilter = this.$watch(
            () => this.filterProduct,
            () => {
              this.getPRoductsWithDelay();
              this.orderRequestItem.product_id = null;
            },
            {
              deep: true,
            }
          );
        });
      } else {
        this.filterProduct = {
          type_id: null,
          group_id: null,
        };
        this.productCode.code = null;
        setTimeout(() => {
          this.clearOrderForm();
          this.currentOrderFormStatus = orderFormStatus.addOrder;
        }, 150);
      }
    },
  },
  created() {
    this.getPRoductsWithDelay = debounce(function () {
      this.getProducts(this.filterProduct);
    }, 300);
    this.getProductWithCode = debounce(
      async function () {
        this.productCode.loading = true;
        try {
          const {
            data: { data },
          } = await this.$http.get(
            "product-item/get-product-by-accounting-code",
            {
              params: { accountingCode: this.productCode.code },
            }
          );
          if (data) {
            this.products = [data];
            this.orderRequestItem.product_id = data.id;
          }
        } catch (e) {
          this.setResponseError({ error: e });
        } finally {
          this.productCode.loading = false;
        }
      }.bind(this),
      300
    );
  },
};
</script>
